








































import { Component, Vue } from "vue-property-decorator";

import RouterInfoTabs from "@/components/app/tabs/router_info/router-info-tabs.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";

import { IRouteCity, IRouteInfo } from "@/@types/routeInfo/route-info";
import { IAutoCoonfig } from "@/@types/_shared/configuration/hotel-configuration";
import { routeInfo, cruiseOffers as cruises } from "@/config/host.config";
import { AxiosResponse, AxiosError, AxiosRequestConfig } from "axios";
import { ICityCode } from "@/@types/_shared/city-code";

interface IAuto {
  auto: boolean;
  ship_code: string;
}

@Component({
  components: { RouterInfoTabs, BSwitch },
})
export default class RouterInfoPage extends Vue {
  tabs: string[] = ["RouteList", "CityList"];

  routeList: Array<IRouteInfo> = [];
  cityList: Array<IRouteCity> = [];
  shipsCode: Array<string> = [];

  activeRoute = "";
  config = this.$store.getters.getAutoConfig.routeInfo;

  get autoConfig(): IAutoCoonfig {
    return this.$store.getters.getAutoConfig;
  }

  changeAutoFormat(toggle: boolean): void {
    if (toggle === this.config) return;
    this.config = toggle;
    this.createRouteList(toggle);
    this.createCityList(toggle);
  }

  deleteRoute(id: string): void {
    const i = this.routeList.findIndex((el) => el._id === id);
    if (i < 0) {
      this.createRouteList(this.autoConfig.routeInfo);
      return;
    }
    this.routeList.splice(i, 1);
  }

  deleteCity(id: string): void {
    const i = this.cityList.findIndex((el) => el._id === id);
    if (i < 0) {
      this.createCityList(this.autoConfig.routeInfo);
      return;
    }
    this.cityList.splice(i, 1);
  }

  async changeAutoParams(auto: boolean): Promise<void> {
    const uri = routeInfo.config;
    const data = { auto };
    try {
      const autoRes = await this.$axios.put(uri, data);
      if (autoRes.status === 200) {
        this.$store.dispatch("changeAuto", { code: "routeInfo", auto: auto });
        this.config = auto;
        this.createRouteList(auto);
        this.createCityList(auto);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      } else
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
    } catch (error) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async changeCity(id: string, data: Partial<IRouteCity>): Promise<void> {
    const method = id ? "put" : "post";
    const url = id ? `${routeInfo.citys}/${id}` : routeInfo.citys;

    try {
      const city = await this.$axios({ url, method, data });
      if (city.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        if (!id) this.cityList.push(city.data);
        else {
          const i = this.cityList.findIndex((el) => el._id == id);
          if (i < 0) this.createRouteList(this.autoConfig.routeInfo);
          else {
            for (const key of Object.keys(data)) {
              this.$set(this.cityList[i], key, data[key as keyof ICityCode]);
            }
          }
        }
        return;
      }
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    } catch (error) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
      console.log(error);
    }
  }

  async changeRoute(
    id: string | undefined,
    data: Partial<IRouteInfo>
  ): Promise<void> {
    const method = id ? "put" : "post";
    const url = id ? `${routeInfo.routes}/${id}` : routeInfo.routes;

    try {
      const route = await this.$axios({ url, method, data });
      if (route.status === 200) {
        if (id && data && data.active !== undefined)
          if (this.activeRoute == id && !data.active) this.activeRoute = "";
          else this.activeRoute = id ? id : "";
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        if (!id) this.routeList.push(route.data);
        else {
          const i = this.routeList.findIndex((el) => el._id == id);
          if (i < 0) this.createRouteList(this.autoConfig.routeInfo);
          else {
            for (const key of Object.keys(data)) {
              this.$set(this.routeList[i], key, data[key as keyof IRouteInfo]);
            }
          }
        }
        return;
      }
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    } catch (error) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
      console.log(error);
    }
  }

  async getRouteConfig(): Promise<void> {
    const url = routeInfo.config;
    try {
      const config: AxiosResponse<IAuto> = await this.$axios.get(url);
      if (config.status === 200) {
        this.$store.dispatch("changeID", config.data.ship_code);
        this.$store.dispatch("changeAuto", {
          code: "routeInfo",
          auto: config.data.auto,
        });
        this.config = config.data.auto;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getRoutes(config: AxiosRequestConfig): Promise<Array<IRouteInfo>> {
    const url: string = routeInfo.routes;
    return new Promise<Array<IRouteInfo>>((res, rej) => {
      this.$axios
        .get(url, config)
        .then((routes: AxiosResponse) => {
          if (routes.status === 200) {
            res(routes.data);
          }
        })
        .catch((error: AxiosError) => {
          rej(error);
        });
    });
  }

  async getCitys(auto: boolean): Promise<Array<IRouteCity>> {
    const url: string = routeInfo.citys;
    const config = { params: { auto } };
    return new Promise<Array<IRouteCity>>((res, rej) => {
      this.$axios
        .get(url, config)
        .then((citys: AxiosResponse) => {
          if (citys.status === 200) res(citys.data);
        })
        .catch((error: AxiosError) => {
          rej(error);
        });
    });
  }

  async getShipsCode(): Promise<string[]> {
    const url: string = cruises.ships;
    const config = {};
    return new Promise<string[]>((res, rej) => {
      this.$axios
        .get(url, config)
        .then((codes: AxiosResponse) => {
          if (codes.status === 200) res(codes.data);
        })
        .catch((error: AxiosError) => {
          rej(error);
        });
    });
  }

  createRouteList(auto: boolean): void {
    const config = { params: { auto } };
    this.getRoutes(config)
      .then((routes: Array<IRouteInfo>) => {
        this.routeList = routes;
        for (const route of this.routeList) {
          if (route.active == true) {
            this.activeRoute = route._id ? route._id : "";
            break;
          }
        }
      })
      .catch(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
      });
  }

  createCityList(auto: boolean): void {
    this.getCitys(auto)
      .then((citys: Array<IRouteCity>) => {
        this.cityList = citys;
      })
      .catch(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
      });
  }

  createShipsCode(): void {
    this.getShipsCode()
      .then((codes: Array<string>) => {
        this.shipsCode = codes;
      })
      .catch(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
      });
  }

  mounted(): void {
    this.getRouteConfig()
      .then(() => {
        this.createRouteList(this.autoConfig.routeInfo);
      })
      .then(() => {
        this.createCityList(this.autoConfig.routeInfo);
      })
      .then(() => {
        this.createShipsCode();
      });
  }
}
